'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    ParkingMapController.$inject = ['$interval', '$q', '$scope', '$state', 'iotService', 'leafletData'];
    angular.module('app.admin').component('parkingMap', {
        require: { app: "^app" },
        template: '<style>\n    .fa.fa-circle.free {\n        color: #5cb85c;\n    }\n    .fa.fa-circle.occupied {\n        color: #d9534f;\n    }\n    .fa.fa-circle.offline {\n        color: rgba(128, 128, 128, 1);\n    }\n</style><div class="row" translate-namespace="admin.parking"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group" translate-namespace="admin.parking.filters"><div class="btn-group btn-group-sm" role="group" aria-label="..."><button type="button" class="btn btn-default" ng-model="$ctrl.form.status" ng-click="$ctrl.onFilterChange()" uib-btn-radio="\'all\'" translate>.All</button> <button type="button" class="btn btn-default" ng-model="$ctrl.form.status" ng-click="$ctrl.onFilterChange()" uib-btn-radio="\'free\'" translate>.Free</button> <button type="button" class="btn btn-default" ng-model="$ctrl.form.status" ng-click="$ctrl.onFilterChange()" uib-btn-radio="\'occupied\'" translate>.Occupied</button> <button type="button" class="btn btn-default" ng-model="$ctrl.form.status" ng-click="$ctrl.onFilterChange()" uib-btn-radio="\'offline\'" translate>.Offline</button></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><leaflet lf-center="$ctrl.mapConfig.center" markers="$ctrl.mapMarkers" events="$ctrl.mapConfig.events" defaults="$ctrl.mapConfig.defaults" maxBounds="$ctrl.mapConfig.maxBounds" width="100%" height="600px"></leaflet></div></div><script type="text/ng-template" id="template/parking-marker.html"><h4 style="margin-top:5px;" ng-init="description_attr = (\'admin.parking.description\' | translate)"> <small> <i class="fa fa-circle" ng-class="$ctrl.selectedMarker.status" aria-hidden="true"></i> </small> {{$ctrl.selectedMarker[description_attr]}} </h4> <div> <p ng-switch="$ctrl.selectedMarker.status" translate-namespace="admin.parking.status"> <span translate-namespace="admin.parking" translate>.Last change</span> {{$ctrl.selectedMarker.since | momentAgo}}. </p> </div></script>',
        controller: ParkingMapController,
        controllerAs: '$ctrl',
        bindings: {
            selectedDevice: '<'
        }
    }).filter('momentAgo', function () {
        return function (input) {
            return moment(input).fromNow();
        };
    });

    function ParkingMapController($interval, $q, $scope, $state, iotService, leafletData) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {

            $ctrl.form = new FormModel();

            $ctrl.mapConfig = {
                center: {
                    lat: 35.33606624806445,
                    lng: 25.135830811294568,
                    zoom: 16
                },
                defaults: {
                    maxZoom: 18,
                    minZoom: 14,
                    // scrollWheelZoom: false,
                    maxBoundsViscosity: 1.0,
                    gestureHandling: true
                },
                maxBounds: {
                    southWest: { lat: 35.32704779, lng: 25.11807234 },
                    northEast: { lat: 35.34993268, lng: 25.14879591 }
                },
                events: {
                    markers: {
                        enable: ['popupopen']
                    }
                }
            };

            leafletData.getMap().then(function (map) {
                map.gestureHandling.enable();
                // map.fitBounds([ [40.712, -74.227], [40.774, -74.125] ]);
            });

            $scope.$on('leafletDirectiveMarker.popupopen', function (event, args) {
                $ctrl.selectedMarker = args.model;
            });

            $ctrl.allMarkers = [];
            $ctrl.mapMarkers = [];

            $ctrl.updater = update();
            $ctrl.updater = $interval(update, 60000, 1000);
        };

        $ctrl.$onDestroy = function () {
            $interval.cancel($ctrl.updater);
        };

        $ctrl.$onChanges = function () {
            if ($ctrl.selectedDevice) {
                $ctrl.selectedMarker = _.find($ctrl.mapMarkers, { id: $ctrl.selectedDevice.id });
                if ($ctrl.selectedMarker) {
                    $ctrl.selectedMarker.focus = true;
                }
            }
        };

        $ctrl.onFilterChange = function () {
            $ctrl.mapMarkers = {};
            if ($ctrl.form.status !== 'all') {
                $ctrl.mapMarkers = _($ctrl.allMarkers).filter(function (o) {
                    return o.status === $ctrl.form.status;
                }).value();
            } else {
                $ctrl.mapMarkers = $ctrl.allMarkers;
            }
        };

        /**
         * 
         */
        function update() {

            var statuses = {
                free: '#5cb85c',
                occupied: '#d9534f',
                offline: '#777'
            };

            $q.all({
                parkingStatuses: iotService.getParkingDevicesWithStatus()
            }).then(function (r) {

                $ctrl.allMarkers = _(r.parkingStatuses).filter(function (o) {
                    return o.latitude || o.longitude;
                }).map(function (o) {
                    return _.assign(o, {
                        message: '<div ng-include src="\'template/parking-marker.html\'"></div>',
                        getMessageScope: function getMessageScope() {
                            return $scope;
                        },
                        lat: o.latitude,
                        lng: o.longitude,
                        focus: false,
                        icon: {
                            prefix: 'fa',
                            icon: 'fa-circle',
                            type: 'vectorMarker',
                            iconColor: '#fff',
                            markerColor: statuses[o.status]
                        }
                    });
                }).keyBy('id').value();

                $ctrl.onFilterChange();
            }).catch(function (error) {

                if (error.status === 401) {
                    $state.go('login');
                }

                console.error('Oops, something went wrong!', error);
            });
        }

        /**
         * 
         */

        var FormModel = function FormModel() {
            _classCallCheck(this, FormModel);

            this.status = 'all';
        };
    }
})();